import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "className", "title", "name", "caption", "required", "defaultValue", "setYear", "setMonth", "setDay", "setValue", "forbidChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef, useCallback, useEffect, useReducer } from "react";
import dayjs from "@/lib/day";
import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import SelectField from "./SelectField";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function createOption(value, format) {
  return {
    value,
    label: `${value}${format}`
  };
}
function selectOption(type, value) {
  const options = (() => {
    if (type === "year") return yearOptions();
    if (type === "month") return monthOptions();
    if (type === "day") return dayOptions();
  })();
  return options.find(option => option.value == value);
}
const cachedOptions = {
  year: null,
  month: null,
  day: null
};
function yearOptions() {
  if (!cachedOptions.year) {
    const now = dayjs();
    const year = now.year();
    const minYear = 1900;
    const options = [];
    for (let i of Array(year - minYear + 1).keys()) {
      const value = minYear + i;
      options.push(createOption(value, "年"));
    }
    cachedOptions.year = options;
  }
  return cachedOptions.year;
}
function monthOptions() {
  if (!cachedOptions.month) {
    const options = [];
    for (let i of Array(12).keys()) {
      const value = i + 1;
      options.push(createOption(value, "月"));
    }
    cachedOptions.month = options;
  }
  return cachedOptions.month;
}
function dayOptions() {
  let daysInMonth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 31;
  if (!cachedOptions.day) {
    const options = [];
    for (let i of Array(daysInMonth).keys()) {
      const value = i + 1;
      options.push(createOption(value, "日"));
    }
    cachedOptions.day = options;
  }
  return cachedOptions.day;
}
function getBirthday(_ref) {
  let {
    year,
    month,
    day
  } = _ref;
  const date = dayjs(`${year}-${month}-01`);
  const lastDay = date.daysInMonth();
  if (lastDay < day) {
    day = lastDay;
  }
  return dayjs(`${year}-${month}-${day}`);
}
const initialState = {
  birthday: "",
  daysInMonth: 31,
  year: "",
  month: "",
  day: ""
};
const BirthdayField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      className,
      title,
      name,
      caption,
      required,
      defaultValue,
      setYear,
      setMonth,
      setDay,
      setValue,
      forbidChange
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const updateState = useCallback((state, key, value) => {
    const newState = _objectSpread(_objectSpread({}, state), {}, {
      [key]: value
    });
    const birthday = getBirthday(newState);
    const daysInMonth = birthday.daysInMonth();
    const formatBirthday = birthday.format("YYYY-MM-DD");
    return {
      birthday: formatBirthday,
      daysInMonth,
      year: birthday.year(),
      month: birthday.month() + 1,
      day: birthday.date()
    };
  }, []);
  const reducer = useCallback((state, action) => {
    switch (action.type) {
      case "year":
        return updateState(state, "year", action.value);
      case "month":
        return updateState(state, "month", action.value);
      case "day":
        return updateState(state, "day", action.value);
      default:
        return state;
    }
  }, []);
  const {
    0: state,
    1: dispatch
  } = useReducer(reducer, initialState);
  const handleYearChange = useCallback(option => {
    dispatch({
      type: "year",
      value: option.value
    });
    if (setYear) {
      setYear(option.value);
    }
  }, []);
  const handleMonthChange = useCallback(option => {
    dispatch({
      type: "month",
      value: option.value
    });
    if (setMonth) {
      setMonth(option.value);
    }
  }, []);
  const handleDayChange = useCallback(option => {
    dispatch({
      type: "day",
      value: option.value
    });
    if (setDay) {
      setDay(option.value);
    }
  }, []);
  const handleYearMenuOpen = useCallback(() => {
    // 初期表示のときは1980年にスクロールする
    if (!state.year) {
      setTimeout(() => {
        const menu = document.querySelector(".react-select__menu-list");
        if (menu) {
          const option = menu.childNodes[80];
          menu.scrollTo(0, option.offsetTop);
        }
      });
    }
  }, [state.year]);
  useEffect(() => {
    if (defaultValue) {
      const valueList = defaultValue.split("-");
      const [year, month, day] = valueList;
      dispatch({
        type: "year",
        value: year
      });
      dispatch({
        type: "month",
        value: month
      });
      dispatch({
        type: "day",
        value: day
      });
    }
  }, [defaultValue]);
  useEffect(() => {
    if (state.birthday.length > 0) {
      setValue(name, state.birthday);
      const input = document.querySelector(`input[name=${name}]`);
      input.dispatchEvent(new Event("input", {
        bubbles: true
      }));
    }
  }, [state.birthday]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, {
        [styles.required]: required,
        [styles.forbidChange]: forbidChange
      }),
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.formGroup,
      children: [/*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: `${name}-y`,
        placeholder: "\u5E74",
        onChange: handleYearChange,
        options: yearOptions(),
        value: selectOption("year", state.year),
        onMenuOpen: handleYearMenuOpen
      }, _props)), /*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: `${name}-m`,
        placeholder: "\u6708",
        onChange: handleMonthChange,
        options: monthOptions(),
        value: selectOption("month", state.month)
      }, _props)), /*#__PURE__*/_jsx(SelectField, _objectSpread({
        name: `${name}-d`,
        placeholder: "\u65E5",
        onChange: handleDayChange,
        options: dayOptions(state.daysInMonth),
        value: selectOption("day", state.day)
      }, _props))]
    }), /*#__PURE__*/_jsx("input", {
      type: "hidden",
      ref: ref,
      name: name,
      value: state.birthday
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
BirthdayField.displayName = "BirthdayField";
export default BirthdayField;